import { combineReducers } from 'redux';

import invitationsReducer from './ducks/invitations';

const reducers = {
  invitations: invitationsReducer,
};

export default combineReducers(reducers);
